import {formatMoney} from "@shopify/theme-currency";

export default {
  methods: {
    formatMoney(value) {
      return formatMoney(value, "${{amount}}");
    },
  },
};
